import { cn } from '@/lib/utils'
import { useSound } from '@/stores/useSoundStore'
import {
  Home,
  MessageSquare,
  Briefcase,
  MessageCircle,
  Volume2,
  VolumeX,
} from 'lucide-react'
import iconImg from '@/assets/icon.png'

interface FooterNavProps {
  activeSection: string
  onNavigate: (section: string) => void
}

export const FooterNav = ({ activeSection, onNavigate }: FooterNavProps) => {
  const { muted, toggleMute } = useSound()

  // "Serviços, Cotação Rápida, Índice, Feedback"
  const tabs = [
    { id: 'vender', label: 'Serviços', icon: Briefcase },
    { id: 'cotacao', label: 'Cotação Rápida', icon: MessageSquare },
    { id: 'index', label: 'Índice', icon: Home },
    { id: 'contato', label: 'Feedback', icon: MessageCircle },
  ]

  return (
    <div className="h-14 bg-[#cccccc] border-t border-gray-500 flex items-end px-4 gap-2 select-none z-30">
      <div className="mr-4 mb-2 shrink-0">
        <img
          src={iconImg}
          alt="Icon"
          className="w-8 h-8 opacity-90 drop-shadow-sm"
        />
      </div>

      <div className="flex-1 flex gap-1 overflow-x-auto pb-0 hide-scrollbar">
        {tabs.map((tab) => {
          const isActive =
            activeSection === tab.id ||
            (tab.id === 'index' && activeSection === '')
          return (
            <button
              key={tab.id}
              onClick={() => onNavigate(tab.id)}
              className={cn(
                'h-11 px-4 md:px-6 rounded-t-lg font-serif font-bold text-xs md:text-sm flex items-center gap-2 transition-all whitespace-nowrap',
                isActive
                  ? 'bg-[#eeeeee] border-t-2 border-l-2 border-r-2 border-white translate-y-[2px] z-10 shadow-none'
                  : 'bg-[#aaaaaa] border-t-2 border-l-2 border-r-2 border-gray-400 text-gray-800 hover:bg-[#bbbbbb] mb-1 shadow-md',
              )}
            >
              <tab.icon className="w-4 h-4" />
              <span className="hidden sm:inline">{tab.label}</span>
            </button>
          )
        })}
      </div>

      <div className="ml-auto mb-3 flex items-center gap-2 shrink-0">
        <button
          onClick={toggleMute}
          className="p-1.5 hover:bg-gray-400 rounded transition-colors"
          title={muted ? 'Unmute' : 'Mute'}
        >
          {muted ? (
            <VolumeX className="w-5 h-5 text-gray-600" />
          ) : (
            <Volume2 className="w-5 h-5 text-gray-800" />
          )}
        </button>
      </div>
    </div>
  )
}
